import { PERM } from '@/shared/auth/types'
import type { NavSection } from '@/app/nav'

/**
 * The Piutang module's sidebar.
 *
 * The first section is titled with the module's short name on purpose: the
 * Beranda card previews the pages of the section whose title matches it.
 *
 * Delivery and collection are not separate menu items. They are views of the
 * same invoices, reached from the stage chips on the monitoring page, so an
 * officer never has to guess which menu an invoice is filed under.
 */
export const PIUTANG_NAV: NavSection[] = [
  {
    title: 'Piutang',
    items: [{ label: 'Monitoring Invoice', to: '/piutang', icon: 'receipt', permCode: PERM.PIUTANG_INVOICE }],
  },
  {
    title: 'Laporan',
    items: [
      { label: 'Aging dan Listing', to: '/piutang/reports', icon: 'chart', permCode: PERM.PIUTANG_INVOICE },
    ],
  },
  {
    title: 'Pengaturan',
    items: [{ label: 'Pengaturan surat', to: '/piutang/settings', icon: 'sliders', permCode: PERM.PIUTANG_SETTINGS }],
  },
  {
    title: 'Akun',
    items: [
      // As in Billing: everybody who reaches the shell has an account.
      { label: 'Notifikasi', to: '/piutang/notifications', icon: 'bell' },
      { label: 'Profil & Preferensi', to: '/piutang/account', icon: 'user', end: true },
    ],
  },
]
